import { createContext } from "react";

const OuterContext = createContext({});

export default OuterContext;